import { getConfig } from '@b2ag/micro-front-tools';
export const appBrands = {
    default: 'aladin',
    Aladin: 'aladin',
    Farmi: 'farmi',
    Episens: 'episens',
    UMG_US: 'umg-us',
};
export let currentAppBrand;
export function getCurrentAppBrand() {
    return getConfig('APP_CONTEXT') || appBrands.default;
}
currentAppBrand = getCurrentAppBrand();
const isCurrentBrand = (brand) => currentAppBrand === brand;
export const isAladin = isCurrentBrand(appBrands.Aladin);
export const isFarmi = isCurrentBrand(appBrands.Farmi);
export const isEpisens = isCurrentBrand(appBrands.Episens);
export const isUMG_US = isCurrentBrand(appBrands.UMG_US);
export function getBrandName() {
    if (isAladin) {
        return 'Aladin.farm';
    }
    if (isFarmi) {
        return 'Farmi';
    }
    if (isEpisens) {
        return 'Episens';
    }
    if (isUMG_US) {
        return 'CMG';
    }
}
//# sourceMappingURL=index.js.map